import { NgModel } from '@angular/forms';

// Trims the field's text in place, so the control re-checks it without sending a new model.
export function trimOnBlur ( model : NgModel ) : void {
  const value = model?.control.value;

  if ( typeof value === 'string' && value !== value.trim() ) {
    model.control.setValue(value.trim(), { emitViewToModelChange: false });
  }
}
